import 'regenerator-runtime/runtime';
import 'flowbite';

Drupal.behaviors.flowbite = {
  isStarted: false,
  attach(context, settings) {
    once('initFlowbite', 'body', context).forEach(el => {
      initFlowbite();
    });
  },
};
